module.exports = __webpack_public_path__ + "static/img/kuang.b0f6ee59.png";